module.exports = __webpack_public_path__ + "img/143-norway.64a08dcb.svg";